/**
 * Global tenant accessor for use outside of React components.
 * Allows the API client to access tenant information without React context.
 */

let currentTenantIdentifier: string | null = null;
let currentAzureTenantId: string | null = null;
let isCatalogContext = false;

/**
 * Sets the current tenant information.
 * Called by TenantProvider when tenant is resolved.
 */
export function setCurrentTenant(
  identifier: string | null,
  azureTenantId: string | null,
  catalogContext: boolean
): void {
  currentTenantIdentifier = identifier;
  currentAzureTenantId = azureTenantId;
  isCatalogContext = catalogContext;
}

/**
 * Gets the tenant identifier for API calls.
 * Returns the tenant identifier or Azure tenant ID, or null for catalog context.
 */
export function getTenantIdentifier(): string | null {
  if (isCatalogContext) {
    return null;
  }
  return currentTenantIdentifier || currentAzureTenantId;
}

/**
 * Checks if the current context is a catalog context (admin operations).
 */
export function isTenantCatalogContext(): boolean {
  return isCatalogContext;
}

/**
 * Clears the current tenant information.
 */
export function clearCurrentTenant(): void {
  currentTenantIdentifier = null;
  currentAzureTenantId = null;
  isCatalogContext = false;
}
